import moment from 'moment';

const transform = res => {
  const data = res?.data?.inspections?.reports || [];

  const transformedData = data.map(item => {
    return {
      ...item,
      assetCondition: item.assetCondition == 'satisfactory' ? 'Satisfactory' : 'Not Satisfactory',
      date: moment(item.date).format('MM/DD/YYYY'),
      defectiveItem: item.defectiveItem ? item.defectiveItem : 'No defects noted'
    };
  });

  return { data: transformedData, total: res?.data?.inspections.total };
};

const transformNonInspection = res => {
  const data = res?.data?.inspections?.reports || [];

  return {
    data,
    total: res?.data?.inspections?.total ?? 0
  };
};

const transformNotClosed = res => {
  const data = res?.data?.inspections?.reports || [];
  console.log(data);
  return {
    data,
    total: res?.data?.inspections?.total ?? 0
  };
};

const transformDownloadImages = res => {
  const data = res?.data?.images || [];
  return {
    data,
    total: data.length
  };
};

export { transform, transformNonInspection, transformNotClosed, transformDownloadImages };
